import { useEffect, useState } from "react";
import { categoriesClass2 } from "../constants/title";
import CategoryButton from "./CategoryButton";
import UserScoreInfo from "../CommanComponents/UserScoreInfo";
import Chapters from "./Chapters";
import useChooseChapter from "../hooks/useChooseChapter";
import { useSelector } from "react-redux";

function ClassHomeDemo2() {
  const [userName, setUserName] = useState("Öğrenci");
  const [userScore, setUserScore] = useState([]);

  const scoreInfo = useSelector((state) => state.score.value);
  const chapterInfo = useSelector((state) => state.chapterValue.value);
  const currentActiveId = chapterInfo.activeId;

  useEffect(() => {
    setUserScore(scoreInfo?.length || 0);
  }, [scoreInfo]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("postUser"));

    if (user) {
      setUserName(user.username);
    }
  }, []);
  const { chooseClass2Chapter, selection, title, activeCategory } =
    useChooseChapter();
  return (
    <div className="flex flex-col xl:flex-row gap-4 min-h-screen">
      {/* Left Sidebar - Category Selection */}
      <div
        className="flex flex-row xl:flex-col w-full xl:w-3/12 bg-white
      rounded-xl shadow-xl px-1 py-4 xl:p-6 overflow-x-auto xl:overflow-x-visible  border-x-12 border-white xl:border-0 "
      >
        <h2
          className="text-lg xl:text-xl font-bold text-center mb-4 xl:mb-6
          bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hidden xl:block"
          style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
        >
          🚀 Choose Chapters
          <p className="text-center text-sm font-normal">Bölümleri Seç</p>
        </h2>
        <div className="w-full h-1 bg-blue-400 rounded-md mb-4 "></div>
        <div className="flex flex-row xl:flex-col gap-2 xl:gap-0 min-w-max xl:min-w-0 ">
          {categoriesClass2.map((category) => (
            <CategoryButton
              key={category.id}
              icon={category.icon}
              id={category.id}
              name={category.name}
              nameTr={category.nameTr}
              color={category.color}
              onClick={() => {
                chooseClass2Chapter(category.id);
              }}
              isActive={currentActiveId === category.id}
            />
          ))}
        </div>
      </div>
      {/* Main Content Area */}

      <div className="flex flex-row gap-2 xl:gap-4 flex-1  ">
        <div
          className="flex-1 xl:w-6/12 min-h-[600px] xl:min-h-screen rounded-xl
        shadow-xl bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"
        >
          <div className="w-full h-full p-6">
            <Chapters
              selection={selection}
              userScore={userScore}
              title={chapterInfo.title}
            />
          </div>
        </div>
        {/* Right Sidebar - Progress Tracking */}
        <div className="hidden [@media(min-width:1200px)]:block  xl:w-3/12 bg-white rounded-xl">
          <UserScoreInfo userName={userName} userScore={userScore} />
        </div>
      </div>
    </div>
  );
}

export default ClassHomeDemo2;
// import { useEffect, useState } from "react";
// import { categoriesClass2 } from "../constants/title";
// import CategoryButton from "./CategoryButton";
// import UserScoreInfo from "../CommanComponents/UserScoreInfo";
// import Chapters from "./Chapters";
// import useChooseChapter from "../hooks/useChooseChapter";
// import { useSelector } from "react-redux";

// function ClassHomeDemo2() {
//   const [userName, setUserName] = useState("Öğrenci");
//   const [userScore, setUserScore] = useState(0); // Başlangıç değerini 0 yaptık (dizi değil sayı bekliyor)

//   // Redux state'lerinin güvenli bir şekilde okunması (Fallback korumaları eklendi)
//   const scoreInfo = useSelector((state) => state.score?.value || []);
//   const chapterInfo = useSelector(
//     (state) => state.chapterValue?.value || { activeId: null, title: "" },
//   );
//   const currentActiveId = chapterInfo.activeId;

//   // Çift useEffect teke düşürüldü ve güvenli hale getirildi
//   useEffect(() => {
//     setUserScore(scoreInfo?.length || 0);
//   }, [scoreInfo]);

//   const { chooseClass2Chapter, selection, title, activeCategory } =
//     useChooseChapter();

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("postUser"));
//     if (user && user.username) {
//       setUserName(user.username);
//     }
//   }, []);

//   return (
//     <div className="flex flex-col xl:flex-row gap-4 min-h-screen">
//       {/* Left Sidebar - Category Selection */}
//       <div className="flex flex-row xl:flex-col w-full xl:w-3/12 bg-white rounded-xl shadow-xl px-1 py-4 xl:p-6 overflow-x-auto xl:overflow-x-visible border-x-12 border-white xl:border-0">
//         <h2
//           className="text-lg xl:text-xl font-bold text-center mb-4 xl:mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hidden xl:block"
//           style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
//         >
//           🚀 Choose Chapters
//           <p className="text-center text-sm font-normal">Bölümleri Seç</p>
//         </h2>
//         <div className="w-full h-1 bg-blue-400 rounded-md mb-4"></div>
//         <div className="flex flex-row xl:flex-col gap-2 xl:gap-0 min-w-max xl:min-w-0">
//           {categoriesClass2.map((category) => (
//             <CategoryButton
//               key={category.id}
//               icon={category.icon}
//               id={category.id}
//               name={category.name}
//               nameTr={category.nameTr}
//               color={category.color}
//               onClick={() => {
//                 chooseClass2Chapter(category.id);
//               }}
//               isActive={currentActiveId === category.id}
//             />
//           ))}
//         </div>
//       </div>

//       {/* Main Content Area */}
//       <div className="flex flex-row gap-2 xl:gap-4 flex-1">
//         <div className="flex-1 xl:w-6/12 min-h-[600px] xl:min-h-screen rounded-xl shadow-xl bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
//           <div className="w-full h-full p-6">
//             {/* selection verisi yüklenene kadar boş veya hatalı renderı engellemek için kontrol */}
//             <Chapters
//               selection={selection || []}
//               userScore={userScore}
//               title={chapterInfo?.title || ""}
//             />
//           </div>
//         </div>
//         {/* Right Sidebar - Progress Tracking */}
//         <div className="hidden [@media(min-width:1200px)]:block xl:w-3/12 bg-white rounded-xl">
//           <UserScoreInfo userName={userName} userScore={userScore} />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ClassHomeDemo2;
